module.exports = __webpack_public_path__ + "static/2014-header-0cab75780b6c0cb87e25e5fe1643541a.jpg";